<template>
  <div class="cf-flex cf-flex--column cf-flex--gap-16">
    <cf-radio-input
      v-model="selectedAmount"
      :name="kebabcase(label)"
      radio-style="box"
      :label="label"
      :label-style="hideLabel ? 'hidden' : 'default'"
      :options="amountOptions"
      :validations="{
        required: true
      }"
    />

    <transition name="fade-down-only-in">
      <cf-text-input
        v-if="selectedAmount === 'custom'"
        v-model="customAmount"
        v-auto-focus
        type="dollars"
        label="Custom Amount"
        :name="`${kebabcase(label)}-custom-amount`"
        :allow-negative="false"
        :validations="{
          required: true,
          min_value: 0.01,
          ...(minValue != null && maxValue != null) && { between: [minValue, maxValue] }
        }"
      />
    </transition>
  </div>
</template>


<script>
  import dollars from '@/filters/dollars';
  import kebabcase from '@/filters/kebabcase';

  import CfRadioInput from '@/view/components/shared/cf-radio-input/index.vue';
  import CfTextInput from '@/view/components/shared/cf-text-input/index.vue';


  export default {
    name: 'CfGiftCardAmountSelect',

    components: {
      CfRadioInput,
      CfTextInput
    },

    inject: {
      $validator: {
        from: '$validator'
      },

      validatedForm: {
        from: 'validatedForm',
        default() {
          return {};
        }
      }
    },

    props: {
      amounts: {
        type: Array,
        required: true,
        validator: array => array.every(val => typeof val === 'number')
      },
      hideLabel: {
        type: Boolean,
        default: false
      },
      label: {
        type: String,
        default: 'Amount'
      },
      maxValue: {
        type: Number,
        default: null
      },
      minValue: {
        type: Number,
        default: null
      },
      modelValue: {
        type: Number,
        default: null
      }
    },

    data() {
      return {
        customAmount: null,
        selectedAmount: null
      };
    },

    computed: {
      amount() {
        const amount = this.selectedAmount === 'custom' ? this.customAmount : this.selectedAmount;
        return amount || 0;
      },

      amountOptions() {
        return [
          ...this.amounts.map(amount => ({
            display: dollars(amount, { trimZeros: true }),
            value: amount
          })),
          {
            display: 'Custom',
            value: 'custom'
          }
        ];
      }
    },

    watch: {
      amount: 'amountChangeHandler'
    },

    created() {
      this.onCreated();
    },

    methods: {
      kebabcase,

      onCreated() {
        if (this.modelValue) {
          if (this.amounts.some(amount => amount === this.modelValue)) {
            this.selectedAmount = this.modelValue;
          }
          else {
            this.selectedAmount = 'custom';
            this.customAmount = this.modelValue;
          }
        }
      },

      amountChangeHandler(amount) {
        this.$emit('update:modelValue', amount);
      }
    }
  };
</script>
